import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {SogAlign} from "@/shared/ui/types/SogAlign";
import {computed} from "vue";

interface Props {
  alignX?: SogAlign
  alignY?: SogAlign
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogFlexRow',
  props: {
    alignX: { default: undefined },
    alignY: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const _style = computed(() => {
  let res = "";
  if (props.alignX) {
    res += "justify-content: " + props.alignX + ";"
  }
  if (props.alignY) {
    res += "align-items: " + props.alignY + ";"
  }
  return res;
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content-flex-row",
    style: _normalizeStyle(_style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})